import { createContext, useContext } from 'react';
import { ChatContextModel } from './props';

const ChatContext = createContext<ChatContextModel | undefined>(undefined);
ChatContext.displayName = 'ChatContext';

const useChatContext = () => useContext(ChatContext);

export { ChatContext, useChatContext };
